import {Component, ViewEncapsulation, OnInit, OnDestroy} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents, IrbModelsEvents } from '@irb-common/events';
import { SecurityMasterService } from '../security-master/security-master.service';
import { BlendedResult } from '../models-new/models.service';
import { IAlertDialogData } from '@irb/app.model';
import { UtilityService } from '@irb-common/services/utility.service';
import {IRebalResponseObject} from "@irb/irb-clients/irb-clients.model";

@Component({ standalone: false,
  selector: 'irb-import-securites-category-dialog',
  templateUrl: './import-securites-category-dialog.component.html',
  styleUrls: ['./import-securites-category-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportSecuritesCategoryDialogComponent implements OnInit, OnDestroy {
  file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string ;
  resultDatas:BlendedResult[] =[];
  isOverwrite: boolean = false;
  updateStatusCount = 0;
  progressTimer: any = null;
  isUiTest = false;

  constructor(
    public dialogRef: MatDialogRef<ImportSecuritesCategoryDialogComponent>,
    public as: AppService,
    public securityMasterService:SecurityMasterService,
    private util: UtilityService
  ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    this.hasFile = this.isValidFile = true;
    if (!this.file.name.endsWith('.csv')) {
      this.isValidFile = false;
      this.invalidFileErrorHeader = "Invalid file format.";
      this.invalidFileErrorMessage = "Extension type must be \".csv\"";
    }
    if (this.as.maxFileUploadSizeExceeded(this.file)) {
      this.triggerMaxFileUploadSizeExceededError();
    }
    this.errorMessage = "";
  }

  private triggerMaxFileUploadSizeExceededError() {
    this.isValidFile = false;
    this.invalidFileErrorHeader = "Invalid file size.";
    this.invalidFileErrorMessage = "File size exceeds 50MB limit.";
  }

  submitFile() {
    const f = new FormData();
    f.append('ImportSecuritie0', this.file, this.file.name);

    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.securityMasterService.importSecuritiesCategoryAsync(f).subscribe({
      next: (response: IRebalResponseObject) => {
        this.updateStatusCount = 0;
        if (this.progressTimer) clearTimeout(this.progressTimer);
        this.updateStatusCount = 0;
        if (response.responseUtilityMap)
          this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
      }, error: () => {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      }
    });
  }

  proceedWithSubmitResponse(res: any) {
    if (res.includes('Max upload size exceeded') || res.includes('499 records and above')) {
      this.triggerMaxFileUploadSizeExceededError();
    } else {
      const response: any = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>')));

      if(response.CSVImportDetails && !response.CSVImportDetails.isCSVInAValidFormat){
        this.errorMessage ="Use our .csv template to prepare your file.";
        return;
      }
      if (response.status && response.status === "fail") {
        if (response.message) {
          this.errorMessage = response.message;
        } else {
          this.isValidFile = false;
        }
        return;
      }

      const inventoried = (response.Inventoried.data && response.Inventoried.data.length > 0);
      const nonInventoried = (response.NonInventoried.data && response.NonInventoried.data.length > 0);
      const unRecognized = (response.unRecognized.data && response.unRecognized.data.length > 0);
      const unRecogCustCategory = (response.unRecogCustCategory.data && response.unRecogCustCategory.data.length > 0);

      response.isImportSecurityCategory = true;
      if(response.Inventoried.data && response.Inventoried.data.length > 0){
        for (const overwriteRecords of response.Inventoried.data) {
          if(overwriteRecords.isCustomCategoryOverridden){
            this.isOverwrite = true;
            const resultData  = {} as BlendedResult;
            resultData.name = overwriteRecords.securitySymbol;
            resultData.status = overwriteRecords.oldCustomCategory;
            resultData.action = overwriteRecords.newCustomCategory;
            this.resultDatas.push(resultData);
          }

        }
      }
      let savingParams: Array<any> = [];
      let inValidSymbolCnt = 0;
      let nonInventoriedsavingParams: Array<any> = [];
      let isCashType: boolean = false;
      if(response.unRecognized.data && response.unRecognized.data.length > 0){
        for(const unRecognizedData of response.unRecognized.data){
          if(this.checkIfValidCustomSymbol(unRecognizedData.securitySymbol)){
            savingParams.push(unRecognizedData);
          }else{
            inValidSymbolCnt++;
          }
        }

        if(inValidSymbolCnt === response.unRecognized.data.length && !inventoried && !nonInventoried && !unRecogCustCategory){
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'warn',
            summary: "Import Security Category",
            detail: " Invalid custom symbol(s) entered."
          });

          this.close();
          return;
        }
      }

      if(response.NonInventoried.data && response.NonInventoried.data.length > 0){
        for(const nonInventoriedData of response.NonInventoried.data){
          if(nonInventoriedData.securityType === "CASH"){
            isCashType = true;
          }else{
            nonInventoriedsavingParams.push(nonInventoriedData);
          }

        }
      }

      if(isCashType && savingParams.length === 0 && nonInventoriedsavingParams.length === 0){
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          dTitle: "Security Result ",
          msg: " Account sweeps cannot be added to iRebal's security master.\n All account sweeps held in accounts will be treated as cash and mapped to the iRebal security with the symbol of $CASH.",
          dProceedBtnLabel: "Close",
          dType: "ERROR"
        } as IAlertDialogData);
        this.close();
        return;
      }

      if(isCashType){
        response.isCashType = isCashType;
      }

      response.unRecognized.data = savingParams;
      response.inValidSymbolCnt = inValidSymbolCnt;
      response.NonInventoried.data = nonInventoriedsavingParams;

      if(unRecogCustCategory){
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
          dTitle:" Undefined Asset Categories ",
          msg:" Asset categories referenced in an imported security file must pre-exist as a menu choice in iRebal's settings, under securities.",
          dCancelBtnLabel: "Cancel",
          dProceedBtnLabel: "Continue",
          onCancel: (() => {
          }).bind(this),
          onProceed: (() => {
            if(this.isOverwrite){
              response.oerwriteData = this.resultDatas;
              this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_OVERWRITE, response);
            }else if(inventoried || nonInventoried ||unRecognized ){
              this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES, response);
            }
          }).bind(this)
        } as IAlertDialogData);
      }else if(this.isOverwrite){
        response.oerwriteData = this.resultDatas;
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_OVERWRITE, response);
      }else if(inventoried || nonInventoried ||unRecognized ){
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES, response);
      }
      this.close();
    }
  }

  checkIfValidCustomSymbol(unRecognizedSymbol: any) {
    let notAllowedSpCharSymbol ;
    let allowedSpCharSymbol ;
    let notAllowedSpCharPattern = /[^~!./#a-zA-Z0-9]/g;
    let allowedSpCharPattern = /[~!./#]/g;
    if(unRecognizedSymbol.match(notAllowedSpCharPattern) && unRecognizedSymbol.match(notAllowedSpCharPattern) != null)
      notAllowedSpCharSymbol = unRecognizedSymbol.match(notAllowedSpCharPattern);
    if(unRecognizedSymbol.match(allowedSpCharPattern) && unRecognizedSymbol.match(allowedSpCharPattern) != null)
      allowedSpCharSymbol = unRecognizedSymbol.match(allowedSpCharPattern);
    if((notAllowedSpCharSymbol && notAllowedSpCharSymbol.length >0) || (allowedSpCharSymbol && allowedSpCharSymbol.length > 2))
      return false;
    else
      return true;
  }

  updateProgressBarStatus(statusId: any) {
    let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
    if (this.isUiTest)
      timeout = 0;
    this.updateStatusCount++;
    this.progressTimer = setTimeout(() => {
      this.actionStatusCheckIntervalStart(statusId);
    }, timeout);
  }

  actionStatusCheckIntervalStart(statusId: any) {
    this.securityMasterService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const responseData = statusResponse.responseData;
        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.requestStatus) {
          reqStatus = statusResponse.responseUtilityMap.requestStatus.trim().toUpperCase();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          this.updateProgressBarStatus(statusId);
        }

        if (reqStatus === 'COMPLETED') {
          this.proceedWithSubmitResponse(responseData);
          if (this.progressTimer) clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }

        if (reqStatus === 'FAILED') {
          this.actionStatusCheckFailed();
        }
      } else {
        this.actionStatusCheckFailed();
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if (this.progressTimer) clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: 'ERROR',
      dTitle: '',
      dProceedBtnLabel: '',
      msg: 'An error occurred processing your request.',
      onProceed: () => {
      }
    } as IAlertDialogData);
  }

  ngOnDestroy() {
    if (this.progressTimer) clearTimeout(this.progressTimer);
  }
}
